// Image format confluence https://confluence.services/display/PC/Image+formats
export const IMAGE_SIZE_160PX = 10;
export const IMAGE_SIZE_320PX = 11;
export const IMAGE_SIZE_640PX = 12;
export const IMAGE_SIZE_960PX = 13;



// WEBPACK FOOTER //
// ./app/components/shared/Images/Image/constants.js